import * as Actions from '../index';
import * as TYPES from '../actions';
import { getQuestion, getQuestionBank, getTag, listTagsBySection } from '../../../api/queries'
import { API, graphqlOperation } from 'aws-amplify'
import { createUserQuizAnswer, updateUserQuizAnswer } from '../../../api/mutations';


export const saveSingleQuestion = (userData) => {
    return {
        type: TYPES.GET_SINGLE_QUESTION,
        data: userData,
    };
}

export const saveSelectedAnswer = (userData) => {
    return {
        type: TYPES.REVIEW_SELECTED_ANSWER,
        data: userData,
    };
}

export const saveQuestionIdForReview = (userData) => {
    return {
        type: TYPES.QUESTION_ID_REVIEW,
        data: userData,
    };
}

export const saveUserQuizAnswer = (userData) => {
    return {
        type: TYPES.USER_QUIZ_ANSWER_SUBMITTED,
        data: userData,
    };
}

export const saveReviewStep = (userData) => {
    return {
        type: TYPES.SAVE_REVIEW_STEP,
        data: userData,
    };
}

export const saveReviewUserQuizId = (userData) => {
    return {
        type: TYPES.SAVE_USER_QUIZ_ID_FOR_REVIEW,
        data: userData,
    };
}
export const saveReviewIfNew = (userData) => {
    return {
        type: TYPES.SAVE_IS_REVIEW_NEW,
        data: userData,
    };
}

export const saveReviewFeedbackStatus = (userData) => {
    return {
        type: TYPES.SAVE_REVIEW_FEEDBACK_STATUS,
        data: userData,
    };
}

export const saveReviewResponse = (userData) => {
    return {
      type: TYPES.SAVE_REVIEW_RESPONSE,
      data: userData,
    };
};

export const saveReviewTags = (userData) => {
    return {
      type: TYPES.SAVE_REVIEW_TAGS,
      data: userData,
    };
};
export const saveReviewTagsResponse = (userData) => {
    return {
      type: TYPES.SAVE_REVIEW_TAGS_RESPONSE,
      data: userData,
    };
};
export const resetReviewReducer = (userData) => {
    return {
      type: TYPES.RESET_REVIEW_REDUCER,
      data: {},
    };
};

export const dispatchGetQuestion = (userData) => {
    return dispatch => {
        try {
            return API.graphql(graphqlOperation(getQuestion, {id: userData})).then(async (result) => {
                dispatch({
                    type: TYPES.UI_STOP_LOADING
                });
                const q = result?.data?.getQuestion;
                if (q) {
                  dispatch(Actions.saveSingleQuestion(q))
                  return result;
                }

                const qbRes = await API.graphql(graphqlOperation(getQuestionBank, { id: userData }));
                dispatch(Actions.saveSingleQuestion(qbRes?.data?.getQuestionBank))
                return result
            })
        } catch (err) {
            console.log("Error in dispatchListStudentsByParent is ", err);
            dispatch({
                type: TYPES.UI_STOP_LOADING
            });
        }
    }
}

export const dispatchUpdateReview = (userData) => {
    return (dispatch) => {
      try {
        return API.graphql(
          graphqlOperation(updateUserQuizAnswer, { input: userData })
        ).then((result) => {
          dispatch({
            type: TYPES.UI_STOP_LOADING,
          });
            console.log("Update user quiz answer is ", result.data.updateUserQuizAnswer);
          dispatch(
            Actions.saveReviewResponse(result.data.updateUserQuizAnswer)
          );
          return result;
        });
      } catch (err) {
        dispatch({
          type: TYPES.UI_STOP_LOADING,
        });
        console.log("Error in submitQuizAnswerUpdate is ", err);
      }
    };
  };

export const dispatchCreateReview = (userData) => {
    return (dispatch) => {
      try {
        return API.graphql(
          graphqlOperation(createUserQuizAnswer, { input: userData })
        ).then((result) => {
          dispatch({
            type: TYPES.UI_STOP_LOADING,
          });
            console.log("create user quiz answer is ", result.data.createUserQuizAnswer);
          dispatch(
            Actions.saveReviewResponse(result.data.createUserQuizAnswer)
          );
          return result;
        });
      } catch (err) {
        dispatch({
          type: TYPES.UI_STOP_LOADING,
        });
        console.log("Error in createUserQuizAnswer ", err);
      }
    };
  };

export const dispatchGetTag = (userData) => {
    return (dispatch) => {
      try {
        return API.graphql(
          graphqlOperation(getTag, { id: userData })
        ).then((result) => {
          dispatch({
            type: TYPES.UI_STOP_LOADING,
          });
            console.log("dispatchGetTag is ", result.data.getTag);
          dispatch(
            Actions.saveReviewTagsResponse(result.data.getTag)
          );
          return result;
        });
      } catch (err) {
        dispatch({
          type: TYPES.UI_STOP_LOADING,
        });
        console.log("Error in dispatchGetTag ", err);
      }
    };
  };
export const dispatchListTagsBySection= (userData) => {
    return (dispatch) => {
      try {
        return API.graphql(
          graphqlOperation(listTagsBySection, userData)
        ).then((result) => {
          dispatch({
            type: TYPES.UI_STOP_LOADING,
          });
          return result?.data?.listTagsBySection?.items;
        });
      } catch (err) {
        dispatch({
          type: TYPES.UI_STOP_LOADING,
        });
        console.log("Error in dispatchGetTag ", err);
      }
    };
  };
